// src/components/auth/PublicRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../authContext.jsx';

export const PublicRoute = ({ restricted = false }) => {
  const { isAuthenticated } = useAuth();
  
  // If route is restricted and user is logged in, redirect to dashboard
  if (restricted && isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // Render child routes
  return <Outlet />;
};